import React from "react"
import autobind from "class-autobind"
import { TextField } from "material-ui"
import * as api from "../../../../api"
import * as timeHelper from "../../../../helpers/timeHelper"
import DoubleField from "../../../../components/common/DoubleField"
import moment from "moment"
import { patchSpecificAccount } from "../../../../actions/AccountActions"
import strings from "../../../../localization/strings"
import { IAccountDocument } from "../../../../models"
import AccountBillingInvoicesTable from "../../../../components/account/AccountBillingInvoicesTable"
import AccountPerEmployeePerMonthRate from "../../../account/settings/AccountPerEmployeePerMonthRate"
interface IProps {
    selectedAccount: IAccountDocument
    readOnly?: boolean
    updateLoadedAccount(loadedAccount: IAccountDocument): Promise<IAccountDocument>
}

interface IState {
    baseFee: string
    yearlyIncrease: string
    loadingInvoices: boolean
    invoices
    monthlyMinimum: string
}

export default class AccountManagerClientTabBilling extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            baseFee: this.props.selectedAccount.BillingInfo ? this.props.selectedAccount.BillingInfo.MonthlyBaseRate.toString() : "",
            yearlyIncrease: (this.props.selectedAccount.AccountSettings && this.props.selectedAccount.AccountSettings.AccountStats && this.props.selectedAccount.AccountSettings.AccountStats.YearlyIncrease !== null && this.props.selectedAccount.AccountSettings.AccountStats.YearlyIncrease !== undefined) ? this.props.selectedAccount.AccountSettings.AccountStats.YearlyIncrease.toString() : "",
            loadingInvoices: false,
            invoices: [],
            monthlyMinimum: this.props.selectedAccount.BillingInfo ? this.props.selectedAccount.BillingInfo.MonthlyMinimum.toString() : ""
        }
        autobind(this)
    }

    componentDidMount(): void {
        this.getInvoices()
    }

    getInvoices() {
        this.setState({ loadingInvoices: true }, () => {
            api.getInvoices(this.props.selectedAccount.Id).then(res => this.setState({ invoices: res.data.data ? res.data.data : [], loadingInvoices: false }))
        })
    }

    saveBaseFee() {
        patchSpecificAccount(this.props.selectedAccount.Id, { BillingInfo: { MonthlyBaseRate: Number(this.state.baseFee) } }, this.props.selectedAccount.TicksSinceChange, (res) => {
            this.props.updateLoadedAccount(res.data as IAccountDocument)
        })
    }

    saveYearlyIncrease() {
        patchSpecificAccount(this.props.selectedAccount.Id, { AccountSettings: { AccountStats: { YearlyIncrease: Number(this.state.yearlyIncrease) } } }, this.props.selectedAccount.TicksSinceChange, (res) => {
            this.props.updateLoadedAccount(res.data as IAccountDocument)
        })
    }

    saveMonthlyMinimum() {
        patchSpecificAccount(this.props.selectedAccount.Id, { BillingInfo: { MonthlyMinimum: Number(this.state.monthlyMinimum), } }, this.props.selectedAccount.TicksSinceChange, (res) => {
            this.props.updateLoadedAccount(res.data as IAccountDocument)
        })
    }

    render() {
        return (
            <div style={{ margin: "20px 30px 20px 30px" }}>
                <div style={{ display: "flex" }}>
                    <div style={{ paddingRight: 10 }}>
                        <TextField
                            floatingLabelText={strings.EmployeePunchedLastMonth}
                            value={this.props.selectedAccount.AccountSettings.AccountStats.OneMonthAgoTotalActiveEmployees}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled
                        />
                        <DoubleField
                            label={strings.BaseFee}
                            value={this.state.baseFee}
                            style={{ width: 400 }}
                            handleChange={(baseFee) => this.setState({ baseFee })}
                            handleOnBlur={() => this.saveBaseFee()}
                            readonly={this.props.readOnly}
                        />
                        <TextField
                            floatingLabelText={strings.SignUp_Date}
                            value={moment(timeHelper.keepConvertUTCToLocal(this.props.selectedAccount.ObjectAudit.CreatedDate)).format("MM/DD/YYYY")}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled
                        />
                        <div style={{ flex: 1, display: "flex" }}>
                            <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                            <DoubleField
                                label={strings.Monthly_Minimum}
                                value={this.state.monthlyMinimum}
                                style={{ width: 400 }}
                                handleChange={(monthlyMinimum) => this.setState({ monthlyMinimum })}
                                handleOnBlur={() => this.saveMonthlyMinimum()}
                                readonly={this.props.readOnly}
                            />
                        </div>
                    </div>
                    <div style={{ padding: "0px 10px" }}>
                        <TextField
                            floatingLabelText={strings.EmployeePunchedCurrentMonth}
                            value={this.props.selectedAccount.AccountSettings.AccountStats.CurrentMonthTotalActiveEmployees}
                            style={{ width: 400 }}
                            underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                            disabled
                        />
                        <div style={{ flex: 1, display: "flex" }}>
                            <span style={{ marginTop: 40, marginRight: 5 }}>%</span>
                            <DoubleField
                                label={strings.YearlyIncrease}
                                value={this.state.yearlyIncrease}
                                style={{ width: 400 }}
                                handleChange={(yearlyIncrease) => {
                                    if (yearlyIncrease.length > 5) return
                                    this.setState({ yearlyIncrease })
                                }}
                                handleOnBlur={() => this.saveYearlyIncrease()}
                                readonly={this.props.readOnly}
                            />
                        </div>
                        <AccountPerEmployeePerMonthRate
                            accountManager
                            account={this.props.selectedAccount}
                            updateLoadedAccount={this.props.updateLoadedAccount}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                </div>
                <div style={{ width: "100%", marginTop: 70 }}>
                    <h3>{strings.RecentInvoices}</h3>
                    <AccountBillingInvoicesTable loadingInvoices={this.state.loadingInvoices} invoices={this.state.invoices} />
                </div>
            </div>
        )
    }
}